const DEFAULT_TRANSLATIONS = {
    bathroomsAbbreviation: '{value}BA',
    bathroomsPlural:
        '{value, plural, zero{{value}BA} one{{value}BA} few{{value}BA} many{{value}BA} other{{value}BA}}',
    bedroomsAbbreviation: '{value}BR',
    bedroomsPlural:
        '{value, plural, zero{{value}BR} one{{value}BR} few{{value}BR} many{{value}BR} other{{value}BR}}',
    byOwnerMessage: 'More properties managed by {PropertyOwner}',
    nextButtonLabel: 'Next',
    prevButtonLabel: 'Previous',
    seeMore: 'See more',
    seeMoreProperties: 'See more properties',
    seoAveragePrice: '{price} avg/night',
    seoTotalPrice: '{price} total',
    sleeps: 'Sleeps {value}',
    sleepsPlural:
        '{value, plural, zero{Sleeps {value}} one{Sleeps {value}} few{Sleeps {value}} many{Sleeps {value}} other{Sleeps {value}}}',
    viewMore: 'View more',
};

const PRICE_SUMMARY = {
    AVERAGE: 'averagePriceSummary',
    TOTAL: 'totalPriceSummary',
};

const RATE_TYPES = {
    AVERAGE: 'averagePrice',
    TOTAL: 'totalPrice',
};

const DEFAULT_BREAKPOINTS = {
    CLICKING: {
        1600: 5,
        1200: 4,
        740: 3,
        400: 2,
        0: 1,
    },
    SCROLLING: {
        // evaluated to match hit thumb height into ~180-260px
        1600: 6, // cropped hit also included, so we need to +1
        1200: 5,
        740: 4,
        400: 3,
        0: 2,
    },
    SCROLLING_SM: {
        1600: 9,
        1200: 7.5,
        992: 6,
        768: 4.5,
        480: 4,
        0: 3,
    },
};

const RECOMMENDATION_WEB_TARGETS = {
    PDP_SIMILAR_PROPERTY: 'PDP_SIMILAR_PROPERTY',
    INQUIRY_SIMILAR_PROPERTY: 'INQUIRY_SIMILAR_PROPERTY',
    PDP_SAME_OWNER_PROPERTY: 'PDP_SAME_OWNER_PROPERTY',
    TB_SIMILAR_PROPERTY: 'TB_SIMILAR_PROPERTY',
    SLP_SIMILAR_PROPERTY: 'SLP_SIMILAR_PROPERTY',
    MLP_SIMILAR_PROPERTY: 'MLP_SIMILAR_PROPERTY',
    HP_SIMILAR_PROPERTY: 'HP_SIMILAR_PROPERTY',
    STAY_SIMILAR_PROPERTY: 'STAY_SIMILAR_PROPERTY',
    HP_SIMILAR_DESTINATION: 'HP_SIMILAR_DESTINATION',
};

const DESTINATION_WEB_TARGETS = {
    PDP_SIMILAR_DESTINATION: 'PDP_SIMILAR_DESTINATION',
    SLP_SIMILAR_DESTINATION: 'SLP_SIMILAR_DESTINATION',
    MLP_SIMILAR_DESTINATION: 'MLP_SIMILAR_DESTINATION',
    HP_SIMILAR_DESTINATION: 'HP_SIMILAR_DESTINATION',
    HP_TYPEAHEAD_DESTINATION: 'HP_TYPEAHEAD_DESTINATION',
    SERP_LARGE_SEARCH_TERM_DESTINATION: 'SERP_LARGE_SEARCH_TERM_DESTINATION',
    SERP_DISCOVER_MORE_DESTINATION: 'SERP_DISCOVER_MORE_DESTINATION',
};

export {
    DEFAULT_TRANSLATIONS,
    DEFAULT_BREAKPOINTS,
    DESTINATION_WEB_TARGETS,
    PRICE_SUMMARY,
    RATE_TYPES,
    RECOMMENDATION_WEB_TARGETS,
};
